<template>
    <v-card class="ma-3 pa-5">
        <h4>Growth Phases</h4>
        <v-data-table
            :headers="headers"
            :items="growthPhases"
            :items-per-page="20"
            :loading="loading"
            class="elevation-1"
        >
            <template v-slot:item.phase_type="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.phase_type"
                ></v-textarea>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="editItem(item)">
                    mdi-content-save-outline
                </v-icon>
                <v-icon class="mr-2" @click="viewItems(item)">
                    mdi-eye-outline
                </v-icon>
                <v-icon class="mr-2" @click="deleteItem(item)">
                    mdi-trash-can-outline
                </v-icon>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <growth-phase-items :growthPhaseId="item.id" />
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GrowthPhaseItems from './GrowthPhaseItems.vue'

export default {
    name: 'GrowthPhaseList',
    components: {
        'growth-phase-items': GrowthPhaseItems,
    },
    data() {
        return {
            loading: false,
            headers: [
                { text: 'ID', value: 'id', align: 'start', sortable: true, width: '10%' },
                { text: 'Phase Type', value: 'phase_type', align: 'start', sortable: false, width: '70%' },
                { text: 'Actions', value: 'actions', sortable: false, width: '20%' },
            ],
        }
    },
    async mounted() {
        this.loading = true
        await this.fetchGrowthPhases()
        this.loading = false
    },
    methods: {
        ...mapActions('cultureGrowthPhase', ['fetchGrowthPhases', 'updateGrowthPhase', 'deleteGrowthPhase']),
        async editItem(item) {
            await this.updateGrowthPhase(item)
            await this.fetchGrowthPhases()
        },
        async deleteItem(item) {
            if (confirm('Are you sure? This will also delete all items in this phase.')) {
                await this.deleteGrowthPhase(item.id)
            }
        },
        viewItems(item) {
            this.$router.push({ name: 'culture-growth-phase-items', params: { phaseId: item.id } })
        },
    },
    computed: {
        ...mapState('cultureGrowthPhase', ['growthPhases']),
    },
}
</script>

<style scoped>
</style>